export var RelativeValueOptions;
(function (RelativeValueOptions) {
    RelativeValueOptions["None"] = "none";
    RelativeValueOptions["AgainstGroups"] = "againstGroups";
    RelativeValueOptions["AgainstGrandTotal"] = "againstGrandTotal";
})(RelativeValueOptions || (RelativeValueOptions = {}));
export var GroupOptions;
(function (GroupOptions) {
    GroupOptions["Collapsed"] = "collapsed";
    GroupOptions["Expanded"] = "expanded";
})(GroupOptions || (GroupOptions = {}));
export var DatapointKind;
(function (DatapointKind) {
    DatapointKind["Measure"] = "measure";
    DatapointKind["Dimension"] = "dimension";
})(DatapointKind || (DatapointKind = {}));
export var ColumnOptionType;
(function (ColumnOptionType) {
    ColumnOptionType[ColumnOptionType["Column"] = 0] = "Column";
    ColumnOptionType[ColumnOptionType["GroupingColumn"] = 1] = "GroupingColumn";
})(ColumnOptionType || (ColumnOptionType = {}));
